
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__seo-home-en",
      function () {
        return require("private-next-pages/__seo-home-en.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__seo-home-en"])
      });
    }
  